import React from 'react'
import styles from './CGU.module.scss'
import { Helmet } from 'react-helmet'

function ConditionOfUse() {
  return (
    <>
      <Helmet>
        <title>Conditions d'utilisation - LAGUINDAWS</title>
        <meta name='robots' content='follow' />
      </Helmet>

      <div className='fadinAnimation'>
        <h2 className='titlePage'>Conditions d'utilisation</h2>

        <div className={styles.content}>
          En utilisant <strong>LAGUINDAWS</strong>, vous acceptez les conditions
          suivantes :
          <br />
          <br />
          <strong>1. Utilisation des services : </strong>
          <p>
            <span>a.</span> Pour accéder à certaines fonctionnalités de nos
            services, il peut vous être demandé de créer un compte utilisateur.
            <br />
            <span>b.</span> Vous êtes responsable de la confidentialité de vos
            informations de connexion et de toutes les activités effectuées sous
            votre compte.
          </p>
          <strong>2. Communications : </strong>
          En utilisant nos services, vous consentez à recevoir des notifications
          et communications relatives à votre compte, à vos projets ou aux
          prestations de <strong>LAGUINDAWS</strong>.
          <br />
          <br />
          <strong>3. Devis et services : </strong>
          Nos prestations peuvent inclure la création de sites web, le
          référencement, le branding, le développement applicatif, et d'autres
          services digitaux.
          <br />
          Toute demande de devis ou de service implique une prise de contact
          préalable et une validation de la part de notre équipe avant
          engagement.
          <br />
          <br />
          <strong>4. Paiements : </strong>
          Les paiements pour les prestations de <strong>LAGUINDAWS</strong> sont
          effectués selon les modalités convenues avec le client (transfert,
          virement bancaire, Orange Money, ou autre moyen sécurisé convenu).
          Aucun projet n’est entamé sans validation d’un acompte.
          <br />
          <br />
          <strong>5. Comportement des utilisateurs : </strong>
          <p>
            <span>a.</span> Tout usage abusif de nos services, tentative de
            fraude ou violation des droits d’autrui est strictement interdit.
            <br />
            <span>b.</span> <strong>LAGUINDAWS</strong> se réserve le droit de
            suspendre ou de résilier un compte ou une collaboration en cas de
            non-respect de ces conditions.
          </p>
          <strong>6. Cookies et technologies similaires : </strong>
          <strong>LAGUINDAWS</strong> utilise des cookies pour améliorer
          l’expérience utilisateur, analyser le trafic et optimiser la
          performance du site.
          <br />
          <br />
          <strong>7. Droits de propriété intellectuelle : </strong>
          <p>
            <span>a.</span> © 2025 Tous les contenus du site{' '}
            <strong>LAGUINDAWS</strong>, produits et outils créés (textes,
            images, logos, vidéos, design, code) sont la propriété exclusive de
            <strong> LAGUINDA</strong>.
            <br />
            <span>b.</span> Toute reproduction, modification ou diffusion sans
            autorisation écrite est strictement interdite.
          </p>
          <strong>8. Modification des conditions : </strong>
          <strong>LAGUINDA</strong> se réserve le droit de mettre à jour ces
          conditions à tout moment pour se conformer aux évolutions légales ou
          techniques.
          <br />
          <br />
          <h3>Politique de Confidentialité</h3>
          La confidentialité de vos informations est une priorité chez{' '}
          <strong>LAGUINDA</strong>. Nous nous engageons à protéger vos données
          conformément aux principes suivants :
          <br />
          <br />
          <strong>Collecte limitée : </strong>
          Nous ne collectons que les informations nécessaires pour fournir nos
          services et assurer un suivi client optimal.
          <br />
          <br />
          <strong>Sécurité des données : </strong>
          Toutes les données sont traitées avec soin, protégées et stockées dans
          un environnement sécurisé conforme aux normes en vigueur.
          <br />
          <br />
          <strong>Partage restreint : </strong>
          Vos informations personnelles ne sont jamais partagées avec des tiers
          sans votre consentement explicite, sauf obligation légale.
          <br />
          <br />
          <strong>Droits des utilisateurs : </strong>
          Vous pouvez à tout moment demander la suppression, la modification ou
          la consultation de vos données personnelles en nous contactant à
          l’adresse suivante :
          <br />
          <br />
          📧 <a href='mailto: contact@laguindaws.com'>contact@laguindaws.com</a>
          <br />
          <br />
          En utilisant nos services, vous reconnaissez avoir lu, compris et
          accepté ces conditions d'utilisation et de confidentialité.
        </div>
      </div>
    </>
  )
}

export default ConditionOfUse
